

import React from 'react';
import { Alert, Typography } from 'antd';

const { Paragraph, Text } = Typography;

const ServicesSection = () => {
  return (
    <div>
      <Paragraph>
        Club Sports Solutions L.L.C. ("Provider") grants Customer a non-exclusive,
        non-transferable right to access and use the TrackBiz software platform for
        Customer's internal business operations during the term of this Agreement.
      </Paragraph>

      <Paragraph>
        TrackBiz is a cloud-based business management platform designed to help small
        businesses manage daily operations and customer interactions.
      </Paragraph>

      <Paragraph>
        <Text strong>TrackBiz may include features such as:</Text>
      </Paragraph>

      <ul>
        <li>Inventory Management</li>
        <li>Point of Sale (POS)</li>
        <li>Order Management</li>
        <li>Customer Management</li>
        <li>Appointment Scheduling</li>
        <li>Reporting and Analytics</li>
        <li>Website Hosting and Business Website Management</li>
        <li>Other features made available by Provider</li>
      </ul>

      <Paragraph>
        As part of the subscription, Provider may create and host a basic business
        website for Customer at no additional charge.
      </Paragraph>

      <Alert
        message="Domain Registration Responsibility"
        description="Customer is solely responsible for purchasing, renewing, and maintaining any domain names used for its website. Domain registration fees are not included in the TrackBiz subscription fee."
        type="info"
        showIcon
        style={{ marginTop: 16, marginBottom: 16 }}
      />

      <Paragraph>
        Provider may update, improve, modify, replace, or discontinue software
        features from time to time as part of ongoing product development,
        maintenance, security improvements, or service enhancements.
      </Paragraph>

      <Paragraph>
        Customer acknowledges that access to certain features may depend upon
        third-party services, integrations, payment processors, hosting providers,
        internet connectivity, or other external systems.
      </Paragraph>
    </div>
  );
};

export default ServicesSection;